import { useEffect, useRef, useState } from "react";
import { useGoogleMapApi } from "@piiqtechnologies/ui-lib";
/**
 * Geocodes an address string to coordinates using the Google Maps JS SDK.
 * Cached per address string. Returns `undefined` while pending, when `address`
 * is empty, or when geocoding fails — callers treat `undefined` as "no region bias".
 */
export const useGeocodeAddress = (address) => {
    const { mapAPiloaded } = useGoogleMapApi();
    const [center, setCenter] = useState(undefined);
    const cacheRef = useRef(new Map());
    useEffect(() => {
        var _a, _b, _c, _d;
        const trimmed = address === null || address === void 0 ? void 0 : address.trim();
        if (!trimmed) {
            setCenter(undefined);
            return;
        }
        const isReady = mapAPiloaded || (typeof window !== "undefined" && !!((_b = (_a = window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.Geocoder));
        if (!isReady || !((_d = (_c = window.google) === null || _c === void 0 ? void 0 : _c.maps) === null || _d === void 0 ? void 0 : _d.Geocoder))
            return;
        const cached = cacheRef.current.get(trimmed);
        if (cached) {
            setCenter(cached);
            return;
        }
        setCenter(undefined);
        let active = true;
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address: trimmed }, (results, status) => {
            if (!active)
                return;
            if (status === "OK" && results && results[0]) {
                const loc = results[0].geometry.location;
                const value = { lat: loc.lat(), lng: loc.lng() };
                cacheRef.current.set(trimmed, value);
                setCenter(value);
            }
            else {
                setCenter(undefined);
            }
        });
        return () => {
            active = false;
        };
    }, [address, mapAPiloaded]);
    return center;
};
